@import "../../mixins.less";

.anchor {
  color: var(--color-tertiary-900);
  text-decoration: underline;
  text-underline-offset: 1px;

  &:active,
  &:hover {
    color: var(--color-secondary-900);
    text-decoration: underline;
  }

  &:focus {
    color: var(--color-secondary-900);
    border-radius: 2px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      bottom: -2px;
      right: -2px;
      border-radius: 2px;
      box-shadow: 0 0 0 2px rgba(10, 144, 231, 0.62);
    }
  }

  &[disabled],
  &.disabled {
    color: var(--color-secondary-900);
    cursor: default;
    opacity: 0.5;
    border: none;
    background: none;
    text-decoration: none;
  }
}

.bold {
  .body2Mixin();

  color: var(--color-tertiary-900);
  text-decoration: none;
}

.boldSmall {
  .baseFont();

  font-size: 0.875rem; // 14px
  line-height: 1.25rem;
  font-weight: bold;
  color: var(--color-tertiary-900);
  text-decoration: none;
}

.bodyText {
  .body3Mixin();

  color: var(--color-tertiary-700);
}

.white {
  color: white;

  &:active,
  &:hover,
  &:focus {
    color: white;
  }
}

.red {
  color: var(--color-red-700);

  &:active,
  &:hover,
  &:focus {
    color: var(--color-red-700);
  }
}
